const krunkScript = require("./krunkScript.js").default;
module.exports = function (rootNamespaceName, scriptConsole, ...runtimeDependencies) {
  const runtimeApi = require("./createKrunkScriptApiContext.js")(krunkScript, scriptConsole, ...runtimeDependencies);
  runtimeApi.context = krunkScript.prefix(runtimeApi.context);
  const globals = {
    [rootNamespaceName]: runtimeApi.context
  };
  return {
    parse: function (sourceCode) {
      return krunkScript.parse(sourceCode, globals, {
        error: error => scriptConsole.error([error])
      });
    }
  };
};